import { useHandler } from "@chatbotgang/etude/react/useHandler";
import { useEffect, useMemo, useState } from "react";

import { Button } from "@/components/Button";

namespace ReloadButton {
  export type Props = Button.Props;
}

const READY_DELAY = 1000;

/**
 * Can only click once.
 * setTimeout to prevent continuous clicks.
 */
const ReloadButton: React.FC<ReloadButton.Props> = ({
  disabled,
  onClick,
  ...props
}) => {
  const [clicked, setClicked] = useState(false);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setReady(true);
    }, READY_DELAY);
    return function cleanUp() {
      clearTimeout(timeout);
    };
  }, []);
  const isDisabled = useMemo(() => {
    return disabled || clicked || !ready;
  }, [clicked, disabled, ready]);
  const clickHandler = useHandler<ReloadButton.Props["onClick"]>((e) => {
    setClicked(true);
    onClick?.(e);
  });
  return <Button {...props} disabled={isDisabled} onClick={clickHandler} />;
};

export { ReloadButton };
